import React, { Component } from "react"
import { graphql, Link } from "gatsby"
import AOS from 'aos'
import Layout from "../layouts"
import Lottie from 'react-lottie';
import { renderHtmlToReact } from "../helpers/html";
import { Helmet } from "react-helmet"
import $ from 'jquery';
import { globalHistory } from "@reach/router"

let path = globalHistory.location.pathname

let acfColor = '#F3A738'

let loaded = false;

var animationData = {
  "v":"5.5.2","fr":30,"ip":0,"op":82,"w":1258,"h":1457,"nm":"_MAIN LOADER","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"E","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0,"y":1},"o":{"x":0.323,"y":0},"t":0,"s":[629,1710.5,0],"to":[0,-163.667,0],"ti":[0,163.667,0]},{"t":35,"s":[629,728.5,0]}],"ix":2},"a":{"a":0,"k":[282.5,375.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[1.475,-1.476],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[2.088,0],[0,0]],"o":[[0,0],[2.088,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.476,1.477],[0,0],[0,0]],"v":[[-282.208,-374.944],[256.917,-374.944],[258.575,-370.944],[129.625,-241.972],[-135.837,-241.972],[-135.837,-65.455],[131.179,-65.455],[196.605,-0.024],[131.134,65.455],[-135.837,65.455],[-135.837,241.948],[151.757,241.948],[280.732,370.943],[279.075,374.944],[-282.208,374.944]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.043000000598,0.109999997008,0.238999998803,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[282.458,375.194],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":159,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":2,"ty":0,"nm":"looping arrows","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":31,"op":113,"st":31,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"blue line animate in 2","refId":"comp_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[631,727.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":0,"op":31,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":7,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Blue Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.952941176471,0.650980392157,0.219607843137,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[53]},{"t":30,"s":[7.8]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[100]},{"t":30,"s":[55]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":9,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":10,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":36,"st":-15,"bm":0}]},{"id":"comp_2","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"orange arrow - 1","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[0]},{"t":82,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":41,"op":82,"st":41,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"blue arrow - 1","refId":"comp_6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Change to Color","np":13,"mn":"ADBE Change To Color","ix":1,"en":1,"ef":[{"ty":2,"nm":"From","mn":"ADBE Change To Color-0001","ix":1,"v":{"a":0,"k":[0.043137256056,0.109803929925,0.239215701818,1],"ix":1}},{"ty":2,"nm":"To","mn":"ADBE Change To Color-0002","ix":2,"v":{"a":0,"k":[0.952941179276,0.65098041296,0.219607844949,1],"ix":2}},{"ty":7,"nm":"Change","mn":"ADBE Change To Color-0003","ix":3,"v":{"a":0,"k":4,"ix":3}},{"ty":7,"nm":"Change By","mn":"ADBE Change To Color-0004","ix":4,"v":{"a":0,"k":1,"ix":4}},{"ty":6,"nm":"Tolerance","mn":"ADBE Change To Color-0010","ix":5,"v":0},{"ty":0,"nm":"Hue","mn":"ADBE Change To Color-0005","ix":6,"v":{"a":0,"k":0.1,"ix":6}},{"ty":0,"nm":"Lightness","mn":"ADBE Change To Color-0006","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"Saturation","mn":"ADBE Change To Color-0007","ix":8,"v":{"a":0,"k":1,"ix":8}},{"ty":6,"nm":"Saturation","mn":"ADBE Change To Color-0011","ix":9,"v":0},{"ty":0,"nm":"Softness","mn":"ADBE Change To Color-0008","ix":10,"v":{"a":0,"k":0.5,"ix":10}},{"ty":7,"nm":"View Correction Matte","mn":"ADBE Change To Color-0009","ix":11,"v":{"a":0,"k":0,"ix":11}}]}],"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[0]},{"t":82,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":41,"op":82,"st":41,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"blue arrow - 1","refId":"comp_6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":41,"s":[0]},{"t":82,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":41,"op":82,"st":41,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"orange arrow - 1","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":41,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":0,"op":41,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"blue arrow - 1","refId":"comp_6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":41,"s":[0.967]}],"ix":2},"w":1258,"h":1457,"ip":0,"op":41,"st":0,"bm":0}]},{"id":"comp_3","layers":[{"ddd":0,"ind":3,"ty":0,"nm":"orange 1","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[631,728,0],"ix":2},"a":{"a":0,"k":[629,728,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":15,"op":30,"st":15,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"orange 1","refId":"comp_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":0,"op":15,"st":0,"bm":0}]},{"id":"comp_4","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Blue Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.952941176471,0.650980392157,0.219607843137,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52]},{"t":15,"s":[6]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"t":15,"s":[54]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":15,"st":-15,"bm":0}]},{"id":"comp_5","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Right Arrow Mask/Excel_Monogram_Loader Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":90,"ix":10},"p":{"a":0,"k":[61.75,74.25,0],"ix":2},"a":{"a":0,"k":[34,50,0],"ix":1},"s":{"a":0,"k":[125,125,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[-0.375,76.375]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.639215985466,0.917646998985,0.831372967888,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-1.477,-1.476],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,-2.088],[0,0],[0,0],[1.477,-1.477],[0,0],[0,0]],"v":[[34.068,-49.566],[34.068,-48.88],[1.232,-16.052],[-31.55,-48.835],[-31.55,-49.566],[-32,-49.566],[-31.6,15.816],[-27.549,20.784],[1.232,49.566],[30.067,20.734],[35,15.746],[35,-49.566]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[33.308,49.015],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":4,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":98,"st":0,"bm":0}]},{"id":"comp_6","layers":[{"ddd":0,"ind":1,"ty":0,"nm":"blue 1","refId":"comp_7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":180,"ix":10},"p":{"a":0,"k":[631,728,0],"ix":2},"a":{"a":0,"k":[629,728,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":15,"op":30,"st":15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"blue 1","refId":"comp_7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1258,"h":1457,"ip":0,"op":15,"st":0,"bm":0}]},{"id":"comp_7","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":15,"st":-15,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Blue Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.238999998803,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[52]},{"t":15,"s":[6]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"t":15,"s":[54]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":15,"st":-15,"bm":0}]},{"id":"comp_8","layers":[{"ddd":0,"ind":1,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 4","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 3","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').end;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1] 2","cl":"1","refId":"comp_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[75,75,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"w":150,"h":150,"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":4,"ty":3,"nm":"Trace Blue Line/Excel_Monogram_Loader Outlines 2: Path 1 [1.1]","cl":"1","sr":1,"ks":{"o":{"a":0,"k":0,"ix":11},"r":{"a":0,"k":0,"ix":10,"x":"var $bm_rt;\nvar pathToTrace = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2')('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathTan = pathToTrace.tangentOnPath(progress);\n$bm_rt = radiansToDegrees(Math.atan2(pathTan[1], pathTan[0]));"},"p":{"a":0,"k":[629,728.5,0],"ix":2,"x":"var $bm_rt;\nvar pathLayer = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2');\nvar progress = $bm_div(thisLayer.effect('Pseudo/ADBE Trace Path')('Pseudo/ADBE Trace Path-0001'), 100);\nvar pathToTrace = pathLayer('ADBE Root Vectors Group')(1)('ADBE Vectors Group')(1)('ADBE Vector Shape');\n$bm_rt = pathLayer.toComp(pathToTrace.pointOnPath(progress));"},"a":{"a":0,"k":[50,50,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Trace Path","np":4,"mn":"Pseudo/ADBE Trace Path","ix":1,"en":1,"ef":[{"ty":0,"nm":"Progress","mn":"Pseudo/ADBE Trace Path-0001","ix":1,"v":{"a":0,"k":83.333,"ix":1,"x":"var $bm_rt;\n$bm_rt = thisComp.layer('Blue Line/Excel_Monogram_Loader Outlines 2').content('Trim Paths 1').start;"}},{"ty":7,"nm":"Loop","mn":"Pseudo/ADBE Trace Path-0002","ix":2,"v":{"a":0,"k":1,"ix":2}}]}],"ip":0,"op":36,"st":-15,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Blue Line/Excel_Monogram_Loader Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1259,1456.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[-99.673,0],[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0]],"o":[[0,0],[0,99.672],[0,0],[99.672,0],[0,0],[0,-99.673],[0,0],[-99.673,0],[0,0],[0,0]],"v":[[-466.5,-161],[-466.5,385.527],[-286.027,566],[286.027,566],[466.5,385.527],[466.5,-385.527],[286.027,-566],[-286.027,-566],[-466.5,-385.527],[-466.5,161]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.043000000598,0.109999997008,0.238999998803,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":65,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[53]},{"t":30,"s":[7.8]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":15,"s":[100]},{"t":30,"s":[55]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":36,"st":-15,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"E","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[969.156,304],[272,304],[273.156,1262.328],[970.313,1262.328]],"c":true},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"Mask 1"}],"w":1258,"h":1457,"ip":17,"op":176,"st":17,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"arrows-animate on ","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"tm":{"a":1,"k":[{"i":{"x":[0.375],"y":[1]},"o":{"x":[0.606],"y":[0]},"t":0,"s":[0]},{"i":{"x":[0.375],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":67,"s":[1.734]},{"i":{"x":[0.829],"y":[0.834]},"o":{"x":[0.167],"y":[0.167]},"t":86,"s":[1.734]},{"t":1171.1708984375,"s":[39.033]}],"ix":2},"w":1258,"h":1457,"ip":0,"op":150,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":1,"nm":"White Solid 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[629,728.5,0],"ix":2},"a":{"a":0,"k":[629,728.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"sw":1258,"sh":1457,"sc":"#ffffff","ip":0,"op":150,"st":0,"bm":0}],"markers":[]
};

function getRelativeURL(x){
  if (x !== undefined){
    return x.replace(/^.*\/\/[^\/]+/, '')
  }
}

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("progress-bar").style.width = scrolled + "%";
}

function validate(input){
  let results = { valid: true, message: "" };
  if (input.value.trim().length < 1){
      results.valid = false;
      results.message = "The email field can't be blank"
  } else if( input.value.indexOf('@') === -1 ){
      results.valid = false;
      results.message = 'Please enter a valid email address';
  }
  return results;
};

function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}


function submitform(form){
  const msg = form.querySelector('#msg-alert');
  const formData = new FormData(form);

  msg.innerText = 'Submitting...';
  fetch('https://admin.excelinstore.com/wp-admin/admin-ajax.php?action=newsletter_signup', {
    method: 'POST',
    body: formData
  }).then(response => response.json()).then(resJson => {
    if(resJson.id !== undefined){
        msg.innerText = "Thank you for subscribing!";
        form.reset();
        setTimeout(() => msg.innerText = '', 3000);
    } else {
        msg.innerText = `There was an error submitting your email: ${resJson.title}.`;
    }
  });
}

class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      delay: 400,
      path: path
    }

    this.wrapAllWordsInSpan = this.wrapAllWordsInSpan.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {

  	var video = document.getElementById("video");
  	var pageContent = document.getElementById("excel-global-header-inner");
  	
  	if (!pageContent.classList.contains('mobile')){

	  	if(video !== null){
			if ( video.readyState === 4 ) {
				video.play();
				video.classList.add('playing');
				video.setAttribute('aria-label', 'Playing. Click enter to pause');
			}else{
			    var intervalId2 = setInterval(function(){
					
					if ( video.readyState === 4 ) {
					    clearInterval(intervalId2);
					    video.play();
					    video.classList.add('playing');
					    video.setAttribute('aria-label', 'Playing. Click enter to pause');
					}else{
						// clearInterval(intervalId2);
					}
				}, 500);
			}
		}else{
			var intervalId = setInterval(function(){
				video = document.getElementById("video");
				if(video !== null){
					if ( video.readyState === 4 ) {
						video.play();
						video.classList.add('playing');
						video.setAttribute('aria-label', 'Playing. Click enter to pause');
					    clearInterval(intervalId);
					}
				}else{
					// clearInterval(intervalId);
				}
			}, 500);
			
		}
	}
  
    const newsletterForms = document.querySelectorAll('.email-form--wrapper form');

    window.onscroll = () => {
      myFunction();
      this.props.data.allWordpressWpServices.edges.map((wpDataObject, i) => {
        this.handleKeyPress(i);
      })
    };


    newsletterForms.forEach(form => { 

      const input = document.getElementById("home-newsletter-email");

      $(form).find('.signup').click(function(evt){
        evt.preventDefault();
        const msg = form.querySelector('#msg-alert');
        const test = validate(input);

        if(test.valid){
            submitform(form);
        } else{
            msg.innerText = test.message;
        }
      });
      $(input).keypress(function(evt){
       
       if(evt.keyCode == 13) {
          evt.preventDefault();
          const msg = form.querySelector('#msg-alert');
          const test = validate(input);

          if(test.valid){
              submitform(form);
          } else{
              msg.innerText = test.message;
          }
        }else{

        }
      });
    }); 

    AOS.init();

    window.onload = () => {
      AOS.refresh();
    }    
  }

  handleKeyPress(i) {
    var elementToBaseScrollOffOf = document.getElementById("iconAnimation"+ i);
    if(elementToBaseScrollOffOf !== null){
      var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
      if(elementToBaseScrollOffOf.getBoundingClientRect().top - window.innerHeight + elementToBaseScrollOffOf.getBoundingClientRect().height/2 < 0){
       this[`iconAnimation${i}`].play()
      }
    }
  }

  componentWillReceiveProps(){ 
    AOS.refresh(); 
  }

  playVideo(){
  	let video = document.getElementById('video');
    video.play();
    video.classList.remove('paused');
    video.classList.add('playing');
    video.setAttribute('aria-label', 'Playing. Click enter to pause');
  }

  pauseplay(){
  	let video = document.getElementById('video');
    if (video.paused) {
        video.play();
        video.classList.remove('paused');
        video.classList.add('playing');
        video.setAttribute('aria-label', 'Playing. Click enter to pause');
    } else {
       	video.pause();
        video.classList.remove('playing');
        video.setAttribute('aria-label', 'Paused. Click enter to play');
        video.classList.add('paused');
    }

    return false;
  }
  pauseplayKeyPress(e){
  	var charCode = e.charCode || e.keyCode;
    if(charCode == 13) {
	  	let video = document.getElementById('video');
	    if (video.paused) {
	        video.play();
	        video.classList.remove('paused');
	        video.classList.add('playing');
	        video.setAttribute('aria-label', 'Playing. Click enter to pause');
	    } else {
	       	video.pause();
	        video.classList.remove('playing');
	        video.setAttribute('aria-label', 'Paused. Click enter to play');
	        video.classList.add('paused');
	    }

	    return false;
	}
  }

  moveElementUp(i){
    var element = document.getElementById('case_study_card_' + i);
    var elementImage = document.getElementById('card_image_' + i);
    if (element !== null){
      var height = element.offsetHeight
      element.style.top = "calc(100% - " + (height) + "px)";
      elementImage.classList.add('active');
    }
  }

  wrapAllWordsInSpan(text, delayForHeroImage){
    let replaceBR = text.replace('<br />', '<div/> ');
    let words = replaceBR.split(' ');
    let spans = '';
    let delay = 150;
    let navReveal = '';
    let stretchHeader = '';
    path = globalHistory.location.pathname
    if(path == "/"){
      delay = delayForHeroImage;
    }else{
      delay = 150;
    }

    if(loaded == true){
    	delay = 150
    }
    words.map((word, i) => {
      spans += '<span data-aos="fade-up" data-aos-delay="' + delay + '" data-aos-anchor=".hero">' + word + ' </span>'
      delay += 150
    })
    if(loaded == false){
	    setTimeout(() => {
	    	this[`excelLogoLoad`].play()
	    }, 500);
	    setTimeout(() => {
	      let animation = document.getElementById('iconAnimation');
	      animation.classList.add('out')
	      AOS.init();
	    }, 3000);
	    setTimeout(() => {
	      let animation = document.getElementById('iconAnimation');
	      animation.classList.add('background')
	    }, 3800);
	    setTimeout(() => {
	      let navReveal = document.getElementById('navReveal');
	      navReveal.classList.add('move')
	    }, 3800);
	    setTimeout(() => {
	      let animation = document.getElementById('iconAnimation');
	      animation.classList.add('zindex')

	      loaded = true
	    }, 4100);
	    return <h1 dangerouslySetInnerHTML={{__html: spans}} />
	}else{
		setTimeout(() => {
			let animation = document.getElementById('iconAnimation');
			animation.classList.add('loaded')
		    animation.classList.add('out')
		    animation.classList.add('background')
			animation.classList.add('zindex')
			let navReveal = document.getElementById('navReveal');
			navReveal.classList.add('loaded')
			navReveal.classList.add('move')

		}, 500);

		return <h1 dangerouslySetInnerHTML={{__html: spans}} />
	}
  }

  moveElementDown(i){
    var element = document.getElementById('case_study_card_' + i);
    var elementImage = document.getElementById('card_image_' + i);
    if (element !== null){
      element.style.top = "calc(100% - 144px)";
      elementImage.classList.remove('active');
    }
  }


  getAnchor300(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "300"
    }else{
      return "300"
    }
  }

  getAnchor600(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "600"
    }else{
      return "300"
    }
  }
  
  getAnchor900(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "900"
    }else{
      return "300"
    }
  }

  getAnchor1200(){
     if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "1200"
    }else{
      return "300"
    }
  }

  fadeRightvsUp(){
    if (typeof window !== 'undefined' && window.innerWidth > 768){
      return "fade-right"
    }else{
      return "fade-up"
    }
  }
  

  render() {

    const pageData = this.props.data.allWordpressPage
    path = globalHistory.location.pathname
    let home = '';

    if(pageData.edges[0].node !== null){
      if(pageData.edges[0].node.acf.home !== ''){
        home = pageData.edges[0].node.acf.home
      }
    }

    let delayForHeroImage = 150
    let separateDelayHeroImage = 0;
    let replaceBR = home.hero.text.replace('<br />', '<div/> ');
    let words = replaceBR.split(' ');
    let count = 0
    let spans = '';

    words.map((word, i) => {
      count++
    })

    if(path == '/'){
      delayForHeroImage = 5000;
      separateDelayHeroImage = 5000 + (count * 150 - 150);
    }else{
      delayForHeroImage = 150;
      separateDelayHeroImage = 0;
    }

    if(loaded == true){
    	delayForHeroImage = 150;
    	separateDelayHeroImage = 0;
    }
    
    words.map((word, i) => {
      delayForHeroImage =  delayForHeroImage + 150
      separateDelayHeroImage = separateDelayHeroImage + 150
    })

    let employeeiterator = 0

    const servicesPostType = this.props.data.allWordpressWpServices

    const caseStudiesPostType = this.props.data.allWordpressWpWork

    let metaData = this.props.data.allWordpressAcfOptions.group[0].edges[0].node.options.meta_data

    if (metaData == null){
      metaData = {
        description: '',
        image: {
          url: ''
        }
      }
    }

    const shuffledEmployees = shuffle(this.props.data.allWordpressWpEmployees.nodes)

    const employeesPostType = shuffledEmployees.slice(0,3);

    if (typeof window === 'undefined'){
      return (
        <Layout>
          <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                "@type": "Organization",
                "name": "Excel",
                "url": "https://excelinstore.com/",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "1021 International Drive",
                  "addressLocality": "Fergus Falls",
                  "addressRegion": "MN",
                  "postalCode": "56537",
                  "addressCountry": "USA"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "customer support",
                  "telephone": "+1-218-998-3800",
                  "email": "contact@excelinstore.com"
                }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                "@type": "Organization",
                "name": "Excel",
                "url": "https://excelinstore.com/",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "1021 International Drive",
                  "addressLocality": "Fergus Falls",
                  "addressRegion": "MN",
                  "postalCode": "56537",
                  "addressCountry": "USA"
                }
              }
            })
          }]}>
          <html lang="en" />
            <meta charSet="utf-8" />
            <title>Excel | Moving Retail Forward</title>
            <meta name="description" content={metaData.description} />
            <meta property="og:title" content={"Excel | Moving Retail Forward"}  />
            <meta property="og:type" content="WebSite" />
            <meta property="og:url" content="https://excelinstore.com/" />
            <meta property="og:image" content={metaData.image.url} />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:description" content={metaData.description} />
            <meta property="og:site_name" content="Excel" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={"Excel | Moving Retail Forward"} />
            <meta name="twitter:description" content={metaData.description} />
            <meta name="twitter:image" content={metaData.image.url} />
            
          
          </Helmet>
          
      </Layout>
      )
    }else{
      var called = false
      window.addEventListener('mousedown', function() {
        if (called === false){
            let elem = document.getElementById('excel-global-header-inner')
            elem.classList.add('using-mouse');
            called = true
        }
      });
      window.onload = () => {
	      AOS.refresh();
	      this.playVideo();
	  }    
      return(
        <Layout>
          <Helmet script={[{
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "WebPage",
              "url": "https://excelinstore.com/",
              "name": "Excel | Moving Retail Forward",
              "author": {
                "@type": "Organization",
                "name": "Excel",
                "url": "https://excelinstore.com/",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "1021 International Drive",
                  "addressLocality": "Fergus Falls",
                  "addressRegion": "MN",
                  "postalCode": "56537",
                  "addressCountry": "USA"
                },
                "contactPoint": {
                  "@type": "ContactPoint",
                  "contactType": "customer support",
                  "telephone": "+1-218-998-3800",
                  "email": "contact@excelinstore.com"
                }
              },
              "description": "We guide clients through the creation of in-store visual merchandising displays and fixtures.",
              "publisher": {
                "@type": "Organization",
                "name": "Excel",
                "url": "https://excelinstore.com/",
                "address": {
                  "@type": "PostalAddress",
                  "streetAddress": "1021 International Drive",
                  "addressLocality": "Fergus Falls",
                  "addressRegion": "MN",
                  "postalCode": "56537",
                  "addressCountry": "USA"
                }
              }
            })
          }]}>
          <html lang="en" />
            <meta charSet="utf-8" />
            <title>Excel | Moving Retail Forward</title>
            <meta name="description" content={metaData.description} />
            <meta property="og:title" content={"Excel | Moving Retail Forward"}  />
            <meta property="og:type" content="WebSite" />
            <meta property="og:url" content="https://excelinstore.com/" />
            <meta property="og:image" content={metaData.image.url} />
            <meta property="og:image:type" content="image/jpeg" />
            <meta property="og:description" content={metaData.description} />
            <meta property="og:site_name" content="Excel" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={"Excel | Moving Retail Forward"} />
            <meta name="twitter:description" content={metaData.description} />
            <meta name="twitter:image" content={metaData.image.url} />
            
          </Helmet>
          <div id="navReveal">&nbsp;</div>
          <div className="lottie-element homepage-animate" id="iconAnimation">
            <div className="inner">

              <Lottie
                ref={instance => (this[`excelLogoLoad`] = instance)}
                options={{
                  loop: false,
                  autoplay: false,
                  animationData: animationData,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                  }
                }}
              />
              </div>
          </div>
         <div className="progress"><div id="progress-bar" style={{backgroundColor: acfColor}}></div></div>
          { home !== null &&
            <div className="pageContent">
              { home.hero.text !== null &&
                <div className="hero home-hero">
                    { 
                      this.wrapAllWordsInSpan(home.hero.text, delayForHeroImage)
                    }
                </div>
              }
              { home.hero.hero_video == 0 &&
                home.hero.hero_images.length > 1 &&
                <div className="carousel--wrapper" data-aos="fade-up" data-aos-anchor=".hero" data-aos-delay={separateDelayHeroImage  + 150}>
                  <div className="carousel">
                    { home.hero.hero_images.map((elem, i) => (
                      <img src={elem.image.url} alt={elem.image.alt} key={"carousel_image_" + i} />
                    ))}
                  </div>
                  { home.hero.hero_flag !== "" &&
                    <div className="images--flag--outer" data-aos="fade-left">
                      <div className="images--flag">
                        <div>{home.hero.hero_flag}</div>
                      </div>
                    </div>
                  }
                </div>
              }
              { home.hero.hero_video == 0 &&
                home.hero.hero_images.length == 1 &&
                <div className="carousel--wrapper" data-aos="fade-up" data-aos-anchor=".hero" data-aos-delay={separateDelayHeroImage  + 150}>
                  <div className="carousel-fake">
                    <img 
                      src={home.hero.hero_images[0].image.url} 
                      alt={home.hero.hero_images[0].image.alt} />
                    
                  </div>
                  { home.hero.hero_flag !== "" &&
                    <div className="images--flag--outer" data-aos="fade-left">
                      <div className="images--flag">
                        <div>{home.hero.hero_flag}</div>
                      </div>
                    </div>
                  }
                </div>
              }
              { home.hero.hero_video == 1 &&
                <div className="video--outer home" data-aos="fade-up" data-aos-delay={separateDelayHeroImage + 150} data-aos-anchor=".hero">
                  <div className="video--inner">
                    <video preload="auto" tabIndex="0"  poster={home.hero.hero_video_image_poster_url} className="video" src={home.hero.hero_video_url} type="video/mp4" ref="vidRef" onClick={() => this.pauseplay()} onKeyPress={(e) => this.pauseplayKeyPress(e)} id="video" muted="true" loop="true"></video>
                  	<div class="play-button">
                  		<svg width="154px" height="154px" viewBox="0 0 154 154" version="1.1"><g id="Desktop" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="University---Desktop" transform="translate(-643.000000, -3469.000000)"><g id="Group-Copy-4" transform="translate(645.000000, 3471.000000)"><g id="Group-18"><circle id="Oval" stroke="#FFFFFF" stroke-width="3" cx="75" cy="75" r="75"></circle><polygon id="Rectangle" fill="#FFFFFF" transform="translate(71.965805, 75.000000) rotate(-315.000000) translate(-71.965805, -75.000000) " points="57.9658053 69.1954583 85.9658053 61 77.7703471 89"></polygon></g></g></g></g></svg>
                  	</div>
                  </div>
                  { home.hero.hero_flag !== "" &&
                    <div className="images--flag--outer" data-aos="fade-left">
                      <div className="images--flag">
                        <div>{home.hero.hero_flag}</div>
                      </div>
                    </div>
                  }
                </div>
              }
              { home.our_approach.body_one &&
                <section className="waypoint navy our_approach" data-aos="fade-up" data-aos-delay={delayForHeroImage + 300} data-aos-anchor=".hero">
                  <div className="content-wrapper">
                    <div className="our_approach__title">
                      <div dangerouslySetInnerHTML={{__html: home.our_approach.title}} data-aos={this.fadeRightvsUp()} data-aos-anchor=".our_approach"></div>
                    </div>
                    <div className="our_approach__body" data-aos="fade-up" dangerouslySetInnerHTML={{__html: home.our_approach.body_one}} />
                    <div className="our_approach__body two" data-aos="fade-up" dangerouslySetInnerHTML={{__html: home.our_approach.body_two}} />
                  </div>
                </section>
              }
              { home.our_process.heading &&
                <section className="waypoint our_processes">
                  <div className="content-wrapper">
                    <div className="our_processes__title">
                      <div dangerouslySetInnerHTML={{__html: home.our_process.title}} data-aos={this.fadeRightvsUp()} data-aos-anchor=".our_processes"/>
                    </div>
                    <div className="our_processes__body" data-aos="fade-up" dangerouslySetInnerHTML={{__html: home.our_process.heading}} />
                  </div>
                  { servicesPostType !== null &&
                    <div className="content-wrapper">
                      <div className="preview-icon--grid">
                      { servicesPostType.edges.map((elem, i) => {
                        var obj = JSON.parse(elem.node.acf.service.preview_icon_home)
                          return(
                            <Link to={'/services/'} activeClassName="active" partiallyActive={true} key={"service_" + i} className="preview-icon--wrapper">
                              <div className="lottie-element" id={"iconAnimation" + i}>
                                <Lottie
                                  ref={instance => (this[`iconAnimation${i}`] = instance)}
                                  options={{
                                    loop: false,
                                    autoplay: false,
                                    animationData:  obj,
                                    rendererSettings: {
                                      preserveAspectRatio: 'xMidYMid slice'
                                    }
                                  }}
                                  
                                  
                                />
                              </div>
                              <div className="preview-title" data-aos="fade-up" dangerouslySetInnerHTML={{__html: elem.node.title}} />
                              <div className="preview-text" data-aos="fade-up" dangerouslySetInnerHTML={{__html: elem.node.acf.service.preview_text}} />
                            </Link>
                            )
                        })
                      }
                      </div>
                    </div>
                  }
                }
                </section>
              }
              { home.our_work.heading &&
                <section className="waypoint our_work">
                  <div className="content-wrapper">
                    <div className="our_work__title">
                      <div dangerouslySetInnerHTML={{__html: home.our_work.title}} data-aos={this.fadeRightvsUp()} data-aos-anchor=".our_work"/>
                    </div>
                    <div className="our_work__body" dangerouslySetInnerHTML={{__html: home.our_work.heading}}/>
                  </div>
                  <div>
                  { caseStudiesPostType !== null &&
                    <div>
                    { caseStudiesPostType.nodes.map((elem, i) => (
                      <div key={"work_" + i} data-aos="fade-up" >

                      { elem.acf.case_study.featured_on_homepage === "yes" &&
                        elem.acf.case_study.service_hero_images !== null &&
                        elem.acf.case_study.service_hero_images[0].image !== null &&
                        <Link to={getRelativeURL(elem.link)} className="cf case_study_card_link" key={"case_study_" + i} onFocus={() => this.moveElementUp(i)} onBlur={ () => this.moveElementDown(i)} onMouseEnter={ () => this.moveElementUp(i)} onMouseLeave={ () => this.moveElementDown(i)}>
                          { elem.acf.case_study !== null &&
                            <div className="cs-outer">
                             { elem.acf.case_study !== null &&
                              <div className="cs-inner">
                                { elem.acf.case_study.service_hero_images.length > 0 &&
                                  elem.acf.case_study.service_hero_images !== null && 
                                  <div id={"card_image_" + i} className="cs-inner--image" style={{'backgroundImage': "url(" + elem.acf.case_study.service_hero_images[0].image.url + ")"}}>
                                    <img
                                      src={elem.acf.case_study.service_hero_images[0].image.url}
                                      alt={elem.acf.case_study.service_hero_images[0].image.alt} />
                                  </div>
                                }
                                { elem.acf.case_study.service_hero_images.length > 1 && 
                                  <div className="js-cs-inner">
                                  { elem.acf.case_study.service_hero_images.map((image, i) => (
                                    <div className="cs-inner--image" style={{'backgroundImage': image.image.url}}>
                                      <img
                                        src={image.image.url}
                                        alt={image.image.alt} /> 
                                    </div>
                                    ))
                                  }
                                  </div>
                                }
                                <div className="cs--pull-tab" id={"case_study_card_" + i}>
                                  { elem.title !== "" &&
                                    <h3>{elem.title}</h3>
                                  }
                                  { elem.acf.case_study.service_preview_description !== "" &&
                                    <div className="cs--copy">{elem.acf.case_study.service_preview_description}</div>
                                  }
                                  <span className="cta no-hover">View Project<span><span></span></span></span>
                                </div>
                              </div>
                             }
                            </div>
                          }
                          </Link>
                        }
                        </div>
                       ))}
                      </div>
                    }
                    </div>
                    <div className="all-work" data-aos="fade-up">
                      <Link to={'/work/'} activeClassName="active" partiallyActive={true} className="cta no-hover large">View all work<span><span></span></span></Link>
                    </div>
                </section>
              }
              { home.hide_email_signup === "no" &&
                <div className="email-signup--callout">
                  <div className="content-wrapper">
                    <div className="title">
                      <div data-aos={this.fadeRightvsUp()} data-aos-anchor=".email-signup--callout">Email List</div>
                    </div>
                    <div className="grid-wrapper push-away">
                      <div className="grid lap-one-half">
                        <div className="push--wrapper">
                          <div className="header" data-aos="fade-up">{ home.email_sign_up.header}</div>
                          <div className="body" data-aos="fade-up" dangerouslySetInnerHTML={{__html: home.email_sign_up.body}}></div>
                        </div>
                      </div>
                      <div className="grid lap-one-half">
                        <div className="email-form--wrapper" data-aos="fade-up">
                          <form className="myform">
                          <label className="hidden-visually" htmlFor="home-newsletter-email">Email Address:</label>
                            <input className="input" id="home-newsletter-email" type="email" name="email" placeholder="Email Address" aria-label="Enter your email address to sign up for our newsletter" />
                            <span className="cta signup"><span><span></span></span></span>
                            <div id="msg-alert"></div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              { home.hide_contact_us === "no"  &&
                <div className="contact--callout">
                  <div className="content-wrapper">
                    <div className="title">
                      <div data-aos={this.fadeRightvsUp()} data-aos-anchor=".contact--callout">Contact Us</div>
                    </div>
                    <div className="grid-wrapper push-away">
                      <div className="grid lap-one-half">
                        <div className="push--wrapper">
                          <div className="header" data-aos="fade-up">{home.contact_us_module.header}</div>
                        </div>
                      </div>
                      <div className="grid lap-one-half">
                        <div className="contact-sample">
                          <div className="employees-sample">
                            { employeesPostType.map((employee, i) => {
                                employeeiterator+=150
                                return(
                                  <img key={"employee_" + i } data-aos="fade-up" src={employee.acf.employee.image.url} data-aos-delay={employeeiterator}/>
                                )
                              }
                            )}
                          </div>
                          <Link to={'/contact/'} data-aos="fade-up" className="cta two-col black">Get In Touch<span><span></span></span></Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>
          }
        </Layout>
      )
    }
  }
}

export default Home

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressAcfOptions {
      group(field: id) {
        edges {
          node {
            options {
              meta_data {
                description
                image {
                  url
                  alt
                }
              }
            }
          }
        }
      }
    }
    allWordpressPage(filter: {template: {eq: "index.php"}}) {
      edges {
        node {
          template
          acf {
            home {
              hero {
                hero_flag
                text
                hero_images {
                  image {
                    alt
                    caption
                    description
                    title
                    url
                  }
                }
                hero_video
                hero_video_url
                hero_video_image_poster_url
              }
              our_approach {
                body_one
                title
                body_two
              }
              our_process {
                heading
                title
              }
              our_work {
                heading
                title
              }
              hide_email_signup
              hide_contact_us
              email_sign_up {
	              body
	              header
	            }
	            contact_us_module {
	              header
	            }
            }
          }
        }
      }
    }
    allWordpressWpServices(sort: {fields: menu_order}) {
      edges {
        node {
          acf {
            service {
              preview_icon_home
              preview_text
            }
          }
          link
          title
        }
      }
    }
    allWordpressWpWork(sort: {order: ASC, fields: menu_order}) {
      nodes {
        acf {
          case_study {
            featured_on_homepage
            service_hero_images {
              image {
                alt
                url
                title
              }
            }
            service_preview_description
          }
        }
        link
        title
      }
    }
    allWordpressWpEmployees {
      nodes {
        acf {
          employee {
            bio
            image {
              url
              title
            }
            linkedin
            role
          }
        }
      }
    }
  }

`
